import { render, staticRenderFns } from "./GiftBoxCampaignsIntegrationsModal.vue?vue&type=template&id=4b8389d0&scoped=true&"
import script from "./GiftBoxCampaignsIntegrationsModal.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsIntegrationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8389d0",
  null
  
)

export default component.exports